import { Component, Input, OnInit } from "@angular/core";
import { VideoDownloadIcons } from "@app/enum/VideoDownloadIcons";
import "./video-download-status.component.scss";

@Component({
    selector: "video-download-status",
    template: require("./video-download-status.component.html")
})

export class VideoDownloadStatusComponent implements OnInit {

    @Input() label: string;
    @Input() icons: VideoDownloadIcons[];

    iconsTooltips: { icon: string, tooltip: string }[] = [];

    private iconTooltipMap = {
        [VideoDownloadIcons.AutoDownload]: { icon: "downloaded", tooltip: "AutoDownloadTooltip" },
        [VideoDownloadIcons.FoundationDownload]: { icon: "key", tooltip: "FoundationDownloadTooltip" }
    };

    ngOnInit(): void {
        this.setIconsAndTooltips();
    }

    private setIconsAndTooltips(): void {
        this.iconsTooltips = this.icons.map(icon => this.iconTooltipMap[icon]);
    }
}

